<template>
  <d-container
    fluid
    class="main-content-container px-0 px-md-2 px-lg-4">
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        sm="12"
        md="6"
        lg="6"
        class="text-left mb-4">
        <span class="text-uppercase page-subtitle">Kalendarz</span>
        <h3 class="page-title">Zaplanowane spotkania</h3>
      </d-col>

      <d-col
        col
        sm="12"
        md="6"
        lg="6"
        class="text-right text-sm-right d-flex justify-content-center align-items-center justify-content-md-end">
        <d-button
          :disabled="!loaded"
          theme="success"
          @click.prevent="$bus.$emit('calendar-add-meeting-popup-show')">
          <i class="material-icons">add</i>
          Planuj spotkanie
        </d-button>
        <d-button
          theme="secondary"
          class="ml-3"
          @click.prevent="reloadMeetings()">
          <i class="material-icons">refresh</i>
          Odśwież
        </d-button>
      </d-col>
    </d-row>
    <d-card
      class="calendar">
      <div class="calendar-heading">
        <div class="calendar-period">{{ period }}</div>
        <div class="calendar-nav-top">
          <a
            href="#prev-month"
            :class="{ 'calendar-nav-top-prev': true, 'is-inactive': !previousMonthIsAvailable }"
            @click.prevent="goToPreviousMonth"
            :title="previousMonthName">
          </a>

          <d-button
            outline
            theme="primary"
            @click.prevent="showToday"
            title="Dzisiaj">
            Pokaż dzisiaj
          </d-button>

          <a
            href="#next-month"
            class="calendar-nav-top-next"
            @click.prevent="goToNextMonth"
            :title="nextMonthName">
          </a>
        </div>
      </div>

      <div class="calendar-heading-days">
        <div class="calendar-heading-day">{{ daysNames.day1.shortPart1 }}<span>{{ daysNames.day1.shortPart2 }}</span></div>
        <div class="calendar-heading-day">{{ daysNames.day2.shortPart1 }}<span>{{ daysNames.day2.shortPart2 }}</span></div>
        <div class="calendar-heading-day">{{ daysNames.day3.shortPart1 }}<span>{{ daysNames.day3.shortPart2 }}</span></div>
        <div class="calendar-heading-day">{{ daysNames.day4.shortPart1 }}<span>{{ daysNames.day4.shortPart2 }}</span></div>
        <div class="calendar-heading-day">{{ daysNames.day5.shortPart1 }}<span>{{ daysNames.day5.shortPart2 }}</span></div>
        <div class="calendar-heading-day">{{ daysNames.day6.shortPart1 }}<span>{{ daysNames.day6.shortPart2 }}</span></div>
        <div class="calendar-heading-day">{{ daysNames.day7.shortPart1 }}<span>{{ daysNames.day7.shortPart2 }}</span></div>
      </div>

      <div
        :class="{ 'calendar-days': true, 'is-loading': !allDataLoaded }">
        <calendar-day
          v-for="(dayData, index) of visibleDays"
          :key="'day-item-' + index"
          @click.native="showDayPopup(dayData.date)"
          :itemData="getMeetingsForDay(dayData.date)"
          :dayData="dayData" />
      </div>

      <div
        v-if="!loaded"
        class="loading-spinner-wrapper">
        <div class="loading-spinner pb-3 pt-3 text-center">
          <span class="loading-spinner-content text-primary">
            Trwa ładowanie danych&hellip;
          </span>
        </div>
      </div>
    </d-card>

    <calendar-meeting-popup
      :allCustomers="clients" />
    <calendar-day-popup />

    <d-alert v-if="loadError" show theme="warning">
      Wczytywanie danych nie powiodło się.
      <a
        href="javascript:window.location.reload();"
        class="alert-link">
        Odśwież stronę
      </a>
      aby spróbować ponownie.
    </d-alert>
  </d-container>
</template>

<script>
import CalendarDay from './CalendarDay';
import CalendarUtils from './../utils/CalendarUtils';
import FormUtils from './../utils/FormUtils.js';
import ListUtils from './../utils/ListUtils.js';
import DaysNames from './../data/days-names.js';
import CalendarMeetingPopup from './../components/popups/CalendarMeetingPopup.vue';
import CalendarDayPopup from './../components/popups/CalendarDayPopup.vue';

export default {
  name: 'calendar',
  components: {
    'calendar-day': CalendarDay,
    'calendar-meeting-popup': CalendarMeetingPopup,
    'calendar-day-popup': CalendarDayPopup
  },
  data () {
    return {
      data: {
        id: 0,
        user_id: 0,
        customer_id: 0,
        date: '',
        time: '',
        important_information: '',
        description: ''
      },
      loaded: false,
      currentYear: null,
      currentMonth: null,
      meetingsData: [],
      clients: [],
      loadedClients: false,
      loadError: false,
      filters: {
        customer_id: null,
        year: null,
        month: null
      }
    };
  },
  computed: {
    allDataLoaded() {
      return this.loadedClients && this.loaded;
    },
    daysNames () {
      return DaysNames;
    },
    period () {
      return CalendarUtils.getMonthName(this.currentMonth) + ' ' + this.currentYear;
    },
    visibleDays () {
      return CalendarUtils.getDaysList(this.currentYear, this.currentMonth);
    },
    previousMonthIsAvailable () {
      if (this.currentMonth === 1 && this.currentYear === 2016) {
        return false;
      }

      return true;
    },
    previousMonthName () {
      if (parseInt(this.currentMonth, 10) === 1) {
        return CalendarUtils.getMonthName(12) + ' ' + (this.currentYear - 1);
      }

      return CalendarUtils.getMonthName(this.currentMonth - 1) + ' ' + this.currentYear;
    },
    nextMonthName () {
      if (parseInt(this.currentMonth, 10) === 12) {
        return CalendarUtils.getMonthName(1) + ' ' + (this.currentYear + 1);
      }

      return CalendarUtils.getMonthName(this.currentMonth + 1) + ' ' + this.currentYear;
    }
  },
  mounted () {
    this.$bus.$on('calendar-refresh', this.reloadMeetings);
    let today = new Date();
    this.currentYear = today.getFullYear();
    this.currentMonth = today.getMonth() + 1;

    this.reloadMeetings();
    this.loadAdditionalData();
  },
  methods: {
    goToPreviousMonth () {
      let currentYear = parseInt(this.currentYear, 10);
      let currentMonth = parseInt(this.currentMonth, 10);
      currentMonth--;

      if (currentMonth === 0) {
        currentMonth = 12;
        currentYear--;
      }

      this.updatePeriod(currentYear, currentMonth);
    },
    goToNextMonth () {
      let currentYear = parseInt(this.currentYear, 10);
      let currentMonth = parseInt(this.currentMonth, 10);
      currentMonth++;

      if (currentMonth > 12) {
        currentMonth = 1;
        currentYear++;
      }

      this.updatePeriod(currentYear, currentMonth);
    },
    updatePeriod (newYear, newMonth) {
      this.loaded = false;
      this.currentYear = parseInt(newYear, 10);
      this.currentMonth = parseInt(newMonth, 10);

      this.reloadMeetings();
    },
    showToday () {
      let today = new Date();
      this.updatePeriod(today.getFullYear(), today.getMonth() + 1);
    },
    showDayPopup (date) {
      this.$bus.$emit('show-calendar-day-popup', date, this.meetingsData, this.clients);
      return true;
    },
    reloadMeetings () {
      ListUtils.loadItemsData(this, {
        method: 'get',
        endpoint: '/api/meetings/items',
        listField: 'meetingsData',
        errorKey: 'loadError',
        loadedKey: 'loaded',
        pagination: 0,
        params: {
          where: {
            year: this.currentYear,
            month: this.currentMonth,
          }
        }
      });
    },
    loadAdditionalData() {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/contacts/all-items',
        method: 'get',
        outputKey: 'clients',
        loadedKey: 'loadedClients',
        errorKey: 'loadError',
        params: {
          pagination: 0,
        }
      });
    },
    getMeetingsForDay (date) {
      let filteredMeetings = this.meetingsData.filter(meeting => meeting.date === date);
      if (filteredMeetings.length) {
        return filteredMeetings;
      }
      return null;
    }
  },
  beforeDestroy () {
    this.$bus.$off('calendar-refresh', this.reloadMeetings);
  }
}
</script>

<style lang="scss" scoped>

.calendar {
  background: #FFF;
  border: 1px solid #CACEDB;
  margin: 0 auto 50px auto;
  max-width: 1400px;
  padding: 0;
  position: relative;
  width: 100%;

  &-heading {
    align-items: center;
    display: flex;
    padding: 2rem;
    position: relative;
    width: 100%;

    h1 {
      font-size: 2.4rem;
      font-weight: 400;
      line-height: 1;
      margin: 0;

      span {
        color: #007bff;
      }
    }

    & > .button {
      margin-left: auto;
      margin-right: 0;
    }

    .calendar-period {
      font-size: 20px;
      text-transform: capitalize;
    }
  }

  &-heading-days {
    display: flex;
  }

  &-heading-day {
    align-items: center;
    background: #fff;
    border: 1px solid #e1e5eb;
    border-left: none;
    border-right: none;
    color: #3D5170;
    display: flex;
    font-size: 1.1rem;
    font-weight: 500;
    justify-content: center;
    height: 3rem;
    text-align: center;
    width: calc(100% / 7);

    &:nth-child(even) {
      background: #f0f0f0;
      border-left: 1px solid #e1e5eb;
      border-right: 1px solid #e1e5eb;
      left: -1px;
      position: relative;
    }
  }

  &-days {
    display: flex;
    flex-wrap: wrap;

    &.is-loading {
      opacity: .25;
    }
  }

  &-nav {
    align-items: center;
    display: flex;
    height: 80px;
    justify-content: center;

    .button {
      justify-content: center;
      width: 150px;
    }

    &-top {
      display: flex;
      left: 50%;
      padding-top: 1px;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);

      &-prev,
      &-next {
        width: 20px;

        &:before,
        &:after {
          background: #007bff;
          content: "";
          display: block;
          height: 2px;
          position: absolute;
          top: 50%;
          transform-origin: 0 50%;
          width: 14px;
        }
      }

      &-prev {
        margin-right: 20px;

        &:before,
        &:after {
          left: 0;
        }

        &:before {
          transform: rotate(-45deg);
        }

        &:after {
          transform: rotate(45deg);
        }

        &.is-inactive {
          opacity: .25;
          pointer-events: none;
        }
      }

      &-next {
        margin-left: 20px;

        &:before,
        &:after {
          transform-origin: 100% 50%;
          right: 0;
        }

        &:before {
          transform: rotate(45deg);
        }

        &:after {
          transform: rotate(-45deg);
        }
      }
    }
  }
}

.loading-spinner-wrapper {
  background: rgba(255, 255, 255, .85);
  bottom: 0;
  border-radius: 5px;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 100;

  .loading-spinner {
    top: 45%;

    &-content {
      font-weight: 500;
    }
  }
}

@media (max-width: 960px) {
  .calendar {
    margin: 1rem auto;
    width: 100%;

    &-heading {
      padding: 1rem;

      h1 {
        font-size: 2rem;
      }

      &-day {
        font-size: 1.2rem;

        & > span {
          display: none;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .calendar {
    &-heading {
      flex-direction: column;
      padding: .75rem;

      &-day {
        font-size: 1.1rem;
      }

      .calendar-period {
        margin-bottom: 10px;
      }

      .calendar-nav-top {
        position: static;
        transform: unset;

        .calendar-nav-top-prev,
        .calendar-nav-top-next {
          position: relative;
        }
      }
    }
  }

}

@media (max-width: 640px) {
  .calendar {
    &-heading {
      h1 {
        font-size: 1.8rem;
      }

      &-day {
        font-size: 0.9rem;
      }
    }

    &-nav {
      height: 50px;

      .button {
        width: 135px;
      }
    }

    // .day {
    //   .day-number {
    //     font-size: 0.75rem;
    //   }
    // }
  }
}
</style>
